<template>
	<EventLayout :event="event" :subtitle="trans('events.description')">
		<template #actions>
			<PrimaryButton :color="Color.Green" @click.stop="save">
				<i class="fa-solid fa-save mr-2"/>
				{{ trans('general.save') }}
			</PrimaryButton>
		</template>
		<TextEditor v-model="event.description" bordered/>
	</EventLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {type Location} from '@/Types/Location'
import {defineProps, ref, type Ref} from 'vue'
import {type Event} from '@/Types/Events/Event'
import EventLayout from '@/Layouts/EventLayout.vue'
import TextEditor from '@/Components/UI/Editor/TextEditor.vue'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'

const props = defineProps<{
	event:Event,
	location:Location,
}>()

const event:Ref<Event> = ref(props.event)
const working:Ref<boolean> = ref(false)

function save():void{
	if(!working.value && event.value){
		working.value = true
		showInfo(trans('general.updating'))
		axios.patch(route('events.update', event.value.id), event.value).then(() => {
			showSuccess(trans('general.updated'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>
